import { FontColorEnum, FontWeightEnum, Typography } from '@acceso/design-system';

type TimeFieldProps = {
  label: string;
  time: string;
};

export function TimeField({ label, time }: TimeFieldProps) {
  return (
    <div className="flex gap-1">
      <Typography color={FontColorEnum.Medium20} weight={FontWeightEnum.Semibold}>
        {`${label}:`}
      </Typography>

      <Typography color={FontColorEnum.Medium20}>{time}</Typography>
    </div>
  );
}
